import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';

@jsonObject
export class SequenceSearchResultCollectionItemResponse {
  @jsonMember readonly id!: Id;
  @jsonMember readonly rid!: string;
  @jsonMember readonly createdAt!: Date;
}
